module.exports = __webpack_public_path__ + "static/media/S2N9-2.890b9bfb.svg";